// extracted by mini-css-extract-plugin
module.exports = {"component":"albums_component_fHp8p","albums":"albums_albums_3KNKs","populated":"albums_populated_YMhYw","actions":"albums_actions_qpOTN"};